import React from "react";
import { Link } from "react-router-dom";

interface BrandLogoProps {
  className?: string;
  linkTo?: string;
}

/**
 * Responsive brand logo with three display modes:
 * - xs (< 640px): Icon only (globe icon)
 * - sm (640-767px): Short text "Intl Orders"
 * - md+ (768px+): Full text "Intl Orders Portal"
 */
const BrandLogo: React.FC<BrandLogoProps> = ({ className = "", linkTo = "/orders" }) => {
  const logoContent = (
    <>
      {/* Icon only on xs screens (< 640px) */}
      <span className="sm:hidden flex items-center justify-center w-10 h-10 bg-blue-600 dark:bg-blue-500 rounded-lg">
        <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z M3.6 9h16.8 M3.6 15h16.8 M12 3a15 15 0 010 18 M12 3a15 15 0 000 18"
          />
        </svg>
      </span>
      {/* Short text on sm screens (640-767px) */}
      <h1 className="hidden sm:block md:hidden text-lg font-bold text-gray-900 dark:text-white">
        Intl Orders
      </h1>
      {/* Full text on md+ screens (768px+) */}
      <h1 className="hidden md:block text-xl font-bold text-gray-900 dark:text-white">
        Intl Orders Portal
      </h1>
    </>
  );

  return (
    <div className={`flex-shrink-0 ${className}`}>
      <Link to={linkTo} className="flex items-center">
        {logoContent}
      </Link>
    </div>
  );
};

export default BrandLogo;
